<template>
    <div class="main">
        <router-view/>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{

    },
}
</script>
<style scoped>
.main{
    display: flex;
    justify-content: center;
}
</style>